<div
  class="upload-image flex-col justify-center align-center"
  [ngClass]="{ 'is-uploaded': previewUrl }"
>
  <ng-container *ngIf="imageUploading; else preview">
    <app-skeleton height="100%" width="100%" [fill]="true"></app-skeleton>
  </ng-container>
  <ng-template #imageInput>
    <img src="assets/images/upload.svg" alt="Upload" />
    <p>Drag and drop here or <span>Upload</span></p>
    <input
      type="file"
      title=""
      (change)="onFileSelction($event)"
      [accept]="allowedImageType"
    />
  </ng-template>
  <!-- uploaded -->
  <ng-template #preview>
    <ng-container *ngIf="previewUrl; else imageInput">
      <div class="upload-image__close">
        <img
          src="assets/images/close.svg"
          alt=""
          (click)="handleRemoveImage()"
        />
      </div>
      <picture>
        <img [src]="previewUrl" alt="" />
      </picture>
    </ng-container>
  </ng-template>
</div>
